import React from "react"
import { ThemeProvider } from "styled-components"

// Import Utilities
import themes from "~utils/themes"

export default ({ children }) => {
  return <ThemeProvider theme={themes["light"]}>{children}</ThemeProvider>
}
